// @ts-check
import Vue from "vue";
// import TopEventsMatchModel from "bto-models/top-events/top-events-match.model";
import CombinedSliderModel from "bto-models/combined-slider/combined-slider.model";
import CombinedSliderRequestService from '@bto-services/api/shared/combined-slider-request-service';
import { COMBINED_SLIDER_ENUMS } from 'bto-models/combined-slider/const';


/**
 * Get Default store state
 * @returns {import('bto-models/combined-slider/interface').ICombinedSliderStore}
 */
function getDefaultState() {
  return {
    value: {
      combineSliderItems: [],
      liveTopEventsMap: {},
    }
  }
}

/**
 * Top event main store, readonly outside of this service
 */
export const combinedSliderStore = Vue.observable(getDefaultState());

/**
 * Get top events from api
 */
export function getCombinedSliderItems() {
  const combinedSliderRequestService = new CombinedSliderRequestService();
  return combinedSliderRequestService.execute().then((resp) => {
    if (resp && resp.data) {
      const combinedSliderModel = new CombinedSliderModel(resp.data);
      const combinedSlider = [];
      /**
       * @type {import('bto-models/top-events/interface').ILiveTopEventsMap}
       */
      const liveTopEventsMap = {};
      combinedSliderModel.items.forEach((item, i) => {
        if (item.type === COMBINED_SLIDER_ENUMS.TOP_EVENTS) {
          const oldIdx = combinedSliderStore.value.liveTopEventsMap[item.matchId];
          // Update with old value to get the live match info insta instead of waiting for next signalr ping
          // Only needed when navigating away from top event widget then back into it
          if (oldIdx > -1) {
            const oldItem = combinedSliderStore.value.combineSliderItems[oldIdx];
            if (oldItem.type === COMBINED_SLIDER_ENUMS.TOP_EVENTS && oldItem.matchIsLive) {
              const updateModel = getUpdateModel(item, oldItem);
              Object.assign(item, updateModel.body);
              item.matchIsLive = oldItem.matchIsLive;
              item.odds[0] = updateModel.market;
            }
          }
          combinedSlider.push(item);
          liveTopEventsMap[item.matchId] = i;
        } else {
          combinedSlider.push(item);
        }
      });
      combinedSliderStore.value.combineSliderItems = combinedSlider;
      combinedSliderStore.value.liveTopEventsMap = liveTopEventsMap;
    }
  });
}

/**
 * Update the live matches in combined slider
 * @param {any} match - live match 
 */
export function updateCSLiveTopEvent(match) {
  const idx = combinedSliderStore.value.liveTopEventsMap[match.matchId];
  const topEventMatch = combinedSliderStore.value.combineSliderItems[idx];
  const updateModel = getUpdateModel(topEventMatch, match);
  Object.assign(combinedSliderStore.value.combineSliderItems[idx], updateModel.body);
  combinedSliderStore.value.combineSliderItems[idx].matchIsLive = true;
  if (updateModel.market) {
    Vue.set(combinedSliderStore.value.combineSliderItems[idx].odds, 0, updateModel.market);
  }
}

/**
 * Filter live outcomes to show only single SBV when multiple are present  
 * Note: This mutates the original market passed inside, make sure to copy it before passing it here
 * @param {{outcomes: {sbv?:string}[]}} market 
 */
function filterSBVOutcomes(market) {
  if (market.outcomes.some(o => o.sbv)) {
    const sbvMap = {};
    market.outcomes.forEach(o => {
      if (!sbvMap[o.sbv]) {
        sbvMap[o.sbv] = [];
      }
      sbvMap[o.sbv].push(o);
    });
    const firstSBVOutcomes = Object.values(sbvMap)[0];
    market.outcomes = firstSBVOutcomes;
  }
}

function getUpdateModel(oldMatch, newMatch) {
  const oldMarket = oldMatch.odds[1] || oldMatch.odds[0];

  // Check if array since mobile map is array, on web it's object
  let market = Array.isArray(newMatch.odds) ? newMatch.odds.find(m => m.marketId === oldMarket.marketId) : newMatch.odds[oldMarket.marketId];
  if (market && market.outcomes && market.outcomes.length > 2) {
    market = { ...market };
    filterSBVOutcomes(market);
  }
  return {
    body: {
      score: newMatch.score,
      points: newMatch.points,
      games: newMatch.games,
      time: newMatch.time,
      isBetStop: newMatch.isBetStop,
      status: newMatch.status,
    },
    market,
  }
}